import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Topbar from '../component/Topbar'
import { BiCalendarPlus } from "react-icons/bi";
import { BiErrorCircle, BiSolidTrash, BiGift, BiUserPlus, BiCheckCircle, BiSearchAlt, BiX, BiMailSend } from "react-icons/bi";
import { PiMicrosoftExcelLogoDuotone } from "react-icons/pi";
import Button from 'react-bootstrap/Button';
import { useForm, SubmitHandler } from "react-hook-form"
import { useSearchParams } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { MultiSelect } from "react-multi-select-component";
import ReactPaginate from 'react-paginate';
import { getImageSrc } from '../utils/imageSrc';
import { useNavigate, useLocation } from 'react-router-dom';
import LoadingScreen from '../component/LoadingScreen';
import { InteractionStatus, InteractionType, InteractionRequiredAuthError, AccountInfo } from "@azure/msal-browser";
import { acquireGetAccessToken } from "../utils/GetGrapApi";
import * as XLSX from "sheetjs-style";
import * as FileSaver from 'file-saver';

import { Buffer } from 'buffer';
import { useLabels, useLang } from '../hooks/useLabels';
import {
    useMsal,
    MsalAuthenticationTemplate,
    useIsAuthenticated,
} from "@azure/msal-react";
import { callMsGraph, checkIsAdmin } from '../callMsGroup';
import Swal from 'sweetalert2';
import { getUserEmails, isOwnerOf } from '../utils/ownerMatch';

// Matches backend RequestSizeLimit on Events/Create, Events/Update, Reward/Create
const MAX_IMAGE_SIZE = 10 * 1024 * 1024;

// Shows a specific alert for size/permission errors. Returns true if handled.
function showSaveError(error: any): boolean {
    const status = error?.response?.status;
    if (status === 413) {
        Swal.fire({ title: 'Image too large', text: 'The uploaded image exceeds the 10 MB limit. Please use a smaller image.', icon: 'error', confirmButtonText: 'OK' });
        return true;
    }
    if (status === 401 || status === 403) {
        Swal.fire({ title: 'Access denied', text: 'Your session may have expired or you do not have permission. Please sign in again.', icon: 'error', confirmButtonText: 'OK' });
        return true;
    }
    return false;
}

interface IFormInput {
    id: string,
    eventNumber: string,
    eventName: string,
    description: string,
    startDate: string,
    endDate: string,
    status: string,
    ConfirmStatus:string,
    BehalStatus: string,
    eventOwner: string,
    file: any
}
interface IFormRewardInput {
    eventId: string,
    rewardName: string,
    file: any,
    qty: string
}
interface IFormMemberInput {
    inputtype: string,
    employeeId: string,
    rewardNumber: string,
    file: any
}




function SuccessModal(props: any) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className={`w-100 text-center ${(props.result === "1") ? "text-success" : "text-danger"}`}>
                    {(props.result === "1") ? <>{props.titleSuccess || 'Save Successful'}</> : <>{props.titleFailed || 'Save Failed'}</>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>
                <p>
                    {(props.result === "1") ? <>{props.msgSuccess || 'Event created successfully'}</> : <>{props.msgFailed || 'Failed to create event. Please try again.'}</>}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={props.onOk}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}
function RewardConfirmModal(props: any) {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.titleText || 'Confirm Delete'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {props.bodyText || 'Are you sure you want to delete this reward item?'}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>{props.cancelText || 'Cancel'}</Button>
                <Button variant="danger" onClick={props.onDelete}>{props.deleteText || 'Delete'}</Button>
            </Modal.Footer>
        </Modal>
    );
}
function MemberConfirmModal(props: any) {

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.titleText || 'Confirm Delete'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {props.bodyText || 'Are you sure you want to delete this member?'}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>{props.cancelText || 'Cancel'}</Button>
                <Button variant="danger" onClick={props.onDelete}>{props.deleteText || 'Delete'}</Button>
            </Modal.Footer>
        </Modal>
    );
}
function BulkDeleteConfirmModal(props: any) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.titleText || 'Confirm Delete'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    {props.bodyText || `Are you sure you want to delete ${props.count} selected item(s)?`}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>{props.cancelText || 'Cancel'}</Button>
                <Button variant="danger" onClick={props.onDelete}>{props.deleteAllText || 'Delete All'}</Button>
            </Modal.Footer>
        </Modal>
    );
}
function DeleteAllConfirmModal(props: any) {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="text-danger">
                    ⚠️ {props.titleText || 'Confirm Delete All'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-2">
                    <strong>{props.warningLabel || 'Warning'}:</strong> {props.warningBody || 'You are about to delete all members shown in the current list'}
                </p>
                {props.filters && (props.filters.keyword || props.filters.status) ? (
                    <div className="alert alert-warning">
                        <strong>{props.activeFiltersLabel || 'Active filters'}:</strong>
                        <ul className="mb-0 mt-2">
                            {props.filters.keyword && <li>{props.keywordLabel || 'Keyword'}: "{props.filters.keyword}"</li>}
                            {props.filters.status && <li>{props.statusLabel || 'Status'}: {props.filters.status === '1' ? (props.receivedLabel || 'Received') : (props.notReceivedLabel || 'Not Received')}</li>}
                        </ul>
                    </div>
                ) : (
                    <div className="alert alert-danger">
                        <strong>{props.allMembersMsg || `All members (${props.total} items) in this event will be deleted`}</strong>
                    </div>
                )}
                <p className="text-danger mb-0">
                    <strong>{props.cannotUndoMsg || 'This action cannot be undone!'}</strong>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>{props.cancelText || 'Cancel'}</Button>
                <Button variant="danger" onClick={props.onDelete}>{props.confirmDeleteAllText || 'Confirm Delete All'}</Button>
            </Modal.Footer>
        </Modal>
    );
}
// ─── Notify Rate-Limit Modal ────────────────────────────────
// Step 1: countdown — แสดงเวลาที่เหลือก่อน send ใหม่ได้
// Step 2: confirm force — ยืนยัน bypass cooldown
function NotifyRateLimitModal(props: {
    show: boolean;
    retryAfterSeconds: number;
    onHide: () => void;
    onForceConfirm: () => void;
    t: (key: string, fallback: string) => string;
}) {
    const [step, setStep] = useState<'waiting' | 'confirm-force'>('waiting');
    const [remaining, setRemaining] = useState(props.retryAfterSeconds);

    useEffect(() => {
        if (props.show) {
            setStep('waiting');
            setRemaining(props.retryAfterSeconds);
        }
    }, [props.show, props.retryAfterSeconds]);

    useEffect(() => {
        if (!props.show || step !== 'waiting') return;
        const timer = setInterval(() => {
            setRemaining(prev => Math.max(0, prev - 1));
        }, 1000);
        return () => clearInterval(timer);
    }, [props.show, step]);

    const fmt = (s: number) => {
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return m > 0 ? `${m}m ${sec.toString().padStart(2, '0')}s` : `${sec}s`;
    };

    const pct = props.retryAfterSeconds > 0
        ? Math.round((remaining / props.retryAfterSeconds) * 100)
        : 0;

    return (
        <Modal show={props.show} onHide={props.onHide} centered>
            {step === 'waiting' ? (
                <>
                    <Modal.Header closeButton style={{
                        border: 'none',
                        padding: '20px 24px 0',
                        background: 'var(--n-0)',
                    }} />
                    <Modal.Body style={{ padding: '8px 32px 28px', textAlign: 'center' }}>
                        {/* Icon */}
                        <div style={{
                            width: 64, height: 64,
                            borderRadius: '50%',
                            background: 'var(--primary-50, #fef2f2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 20px',
                            border: '2px solid var(--primary-100, #fecaca)',
                        }}>
                            <BiMailSend size={30} style={{ color: 'var(--primary-500)' }} />
                        </div>

                        <h5 style={{ fontWeight: 700, color: 'var(--n-900)', marginBottom: 8 }}>
                            {props.t('modal.notify_wait_title', 'Notification Already Sent')}
                        </h5>
                        <p style={{ color: 'var(--n-500)', fontSize: '0.88rem', marginBottom: 24 }}>
                            {props.t('modal.notify_wait_body', 'Please wait before sending again.')}
                        </p>

                        {/* Countdown badge */}
                        <div style={{
                            display: 'inline-flex', alignItems: 'center', gap: 10,
                            background: 'var(--primary-50, #fef2f2)',
                            border: '1.5px solid var(--primary-200, #fca5a5)',
                            borderRadius: 'var(--r-lg, 12px)',
                            padding: '12px 28px',
                        }}>
                            <span style={{
                                fontSize: '2rem', fontWeight: 800,
                                color: 'var(--primary-500)',
                                fontVariantNumeric: 'tabular-nums',
                                letterSpacing: 1,
                            }}>
                                {fmt(remaining)}
                            </span>
                        </div>

                        {/* Progress bar */}
                        <div style={{
                            marginTop: 16,
                            height: 4,
                            borderRadius: 99,
                            background: 'var(--n-100, #f1ede9)',
                            overflow: 'hidden',
                        }}>
                            <div style={{
                                width: `${pct}%`,
                                height: '100%',
                                background: 'var(--brand-grad)',
                                transition: 'width 1s linear',
                            }} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{
                        border: 'none',
                        padding: '0 24px 20px',
                        gap: 10,
                        justifyContent: 'center',
                    }}>
                        <Button
                            variant='light'
                            onClick={props.onHide}
                            style={{ minWidth: 100, fontWeight: 600 }}
                        >
                            {props.t('btn.ok', 'OK')}
                        </Button>
                        <Button
                            onClick={() => setStep('confirm-force')}
                            style={{
                                minWidth: 140, fontWeight: 600,
                                background: 'var(--brand-grad)',
                                border: 'none',
                                boxShadow: 'var(--sh-brand)',
                            }}
                        >
                            <BiMailSend size={16} className='me-1' />
                            {props.t('btn.force_send', 'Force Send')}
                        </Button>
                    </Modal.Footer>
                </>
            ) : (
                <>
                    <Modal.Header closeButton style={{
                        border: 'none',
                        padding: '20px 24px 0',
                        background: 'var(--n-0)',
                    }} />
                    <Modal.Body style={{ padding: '8px 32px 28px', textAlign: 'center' }}>
                        {/* Warning icon */}
                        <div style={{
                            width: 64, height: 64,
                            borderRadius: '50%',
                            background: '#fef3c7',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 20px',
                            border: '2px solid #fde68a',
                            fontSize: '1.8rem',
                        }}>
                            ⚠️
                        </div>
                        <h5 style={{ fontWeight: 700, color: 'var(--n-900)', marginBottom: 8 }}>
                            {props.t('modal.force_send_title', 'Confirm Force Send')}
                        </h5>
                        <p style={{ color: 'var(--n-500)', fontSize: '0.88rem', marginBottom: 0 }}>
                            {props.t('modal.force_send_body', 'This will bypass the cooldown and send the notification immediately. Are you sure?')}
                        </p>
                    </Modal.Body>
                    <Modal.Footer style={{
                        border: 'none',
                        padding: '0 24px 20px',
                        gap: 10,
                        justifyContent: 'center',
                    }}>
                        <Button
                            variant='light'
                            onClick={() => setStep('waiting')}
                            style={{ minWidth: 100, fontWeight: 600 }}
                        >
                            {props.t('btn.back', 'Back')}
                        </Button>
                        <Button
                            onClick={props.onForceConfirm}
                            style={{
                                minWidth: 140, fontWeight: 600,
                                background: 'var(--brand-grad)',
                                border: 'none',
                                boxShadow: 'var(--sh-brand)',
                            }}
                        >
                            <BiMailSend size={16} className='me-1' />
                            {props.t('btn.force_send', 'Force Send')}
                        </Button>
                    </Modal.Footer>
                </>
            )}
        </Modal>
    );
}

function Events(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const searchInputRef = useRef<HTMLInputElement>(null);
    const [id, setId] = useState("00");
    const [rewardId, setRewardId] = useState(0);
    const [createEvId, setCreateEvId] = useState("");
    const [memberId, setMemberId] = useState(0);
    const [rewardLists, setRewardLists] = useState([]);
    const [memberLists, setMemberLists] = useState<{ memberLists: any[], offset: number, limit: number, totalPages: number, total: number }>({ memberLists: [], offset: 0, limit: 5, totalPages: 0, total: 0 });
    const [totalMembersInEvent, setTotalMembersInEvent] = useState(0);
    const [totalReceivedInEvent, setTotalReceivedInEvent] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams();
    const eventId = searchParams.get("id");
    const hashTab  = location.hash.replace('#', '');
    const activeTab = (hashTab === 'items' || hashTab === 'employee') && eventId == null
        ? 'event'
        : hashTab || 'event';
    const [rewardModalShow, setRewardModalShow] = useState(false);
    const [memberModalShow, setMemberModalShow] = useState(false);
    const [successModalShow, setSuccessModalShow] = useState(false);
    const [createStatus, setCreateStatus] = useState("");
    const [sendingEmail, setSendingEmail] = useState(false);
    const [notifyModal, setNotifyModal] = useState({ show: false, retryAfterSeconds: 0 });
    const { register, handleSubmit, setValue, reset, getValues, formState: { isDirty } } = useForm<IFormInput>()
    const { register: registerReward, handleSubmit: submitReward, reset: resetReward } = useForm<IFormRewardInput>()
    const { register: registerMember, handleSubmit: submitMember, reset: resetMember } = useForm<IFormMemberInput>()
    const [memberInputType, setMemberInputType] = useState(1);
    const [rewardOptions, setRewardOptions] = useState([]);
    const [rewardSelected, setRewardSelected] = useState([]);
    const [memberErrorStatus, setMemberErrorStatus] = useState(false);
    const [memberErrorMessage, setMemberErrorMessage] = useState("Failed to add employee. Please check the information.");
    const [memberSuccessStatus, setMemberSuccessStatus] = useState(false);
    const [memberSuccessMessage, setMemberSuccessMessage] = useState("Employee added successfully");
    const [memberGroup, setMemberGroup] = useState(0);
    const [filter, setFilter] = useState({ offset: 0, limit: 18 });
    const [searchKeyword, setSearchKeyword] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [rewardAdding, setRewardAdding] = useState(false);
    const [memberUploading, setMemberUploading] = useState(false);
    const [selectedMembers, setSelectedMembers] = useState<number[]>([]);
    const [selectAll, setSelectAll] = useState(false);
    const [bulkDeleteModalShow, setBulkDeleteModalShow] = useState(false);
    const [deleteAllModalShow, setDeleteAllModalShow] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [emailList, setEmailList] = useState<string[]>([]);
    const [currentEmail, setCurrentEmail] = useState("");
    const [ownerSuggestions, setOwnerSuggestions] = useState<{ displayName: string; mail: string }[]>([]);
    const [ownerSearchLoading, setOwnerSearchLoading] = useState(false);
    const ownerSearchTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [previewImage, setPreviewImage] = useState<string>("");
    const [imageWarning, setImageWarning] = useState<string | null>(null);
    const { inProgress, instance, accounts } = useMsal();
    const [token, setToken] = useState("");
    const [lang] = useLang();
    const { t } = useLabels('admin', token, 'en');
    const [profile, setProfile] = useState({ jobTitle: "", mail: "", userPrincipalName: "" });
    const [photoData, setPhotoData] = useState("");
    const [tokenProfile, setTokenProfile] = useState("");
    const [stateLoad, setStateLoad] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [eventdata, setEventdata] = useState({
        owner: "",
    })
    const auth = {
        headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")
        },
    };
    const authPut = {
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")
        },
    };

    
    const onSubmit: SubmitHandler<IFormInput> = (data) => {
        setSaving(true)

        // Backend rejects request bodies over 10MB (RequestSizeLimit) with 413
        if (data.file && data.file.length > 0 && data.file[0].size > MAX_IMAGE_SIZE) {
            Swal.fire({ title: 'Image too large', text: 'Event image must not exceed 10 MB', icon: 'warning', confirmButtonText: 'OK' });
            setSaving(false);
            return;
        }

        // Validation for required fields when creating new event
        if (eventId === null) {
            // Check if Event Name is provided
            if (!data.eventName || data.eventName.trim() === '') {
                Swal.fire({ title: 'Required', text: 'Please enter event name', icon: 'warning', confirmButtonText: 'OK' });
                setSaving(false);
                return;
            }

            // Check if Start Date is provided
            if (!data.startDate) {
                Swal.fire({ title: 'Required', text: 'Please select start date', icon: 'warning', confirmButtonText: 'OK' });
                setSaving(false);
                return;
            }

            // Check if End Date is provided
            if (!data.endDate) {
                Swal.fire({ title: 'Required', text: 'Please select end date', icon: 'warning', confirmButtonText: 'OK' });
                setSaving(false);
                return;
            }

            // Check if Event Image is provided
            if (!data.file || data.file.length === 0) {
                Swal.fire({ title: 'Required', text: 'Please upload event image', icon: 'warning', confirmButtonText: 'OK' });
                setSaving(false);
                return;
            }

            // Check if Event Owner(s) is provided
            if (emailList.length === 0) {
                Swal.fire({ title: 'Required', text: 'Please add at least 1 Event Owner', icon: 'warning', confirmButtonText: 'OK' });
                setSaving(false);
                return;
            }
        }

        // Validate date range (for both create and edit)
        if (data.startDate && data.endDate) {
            const startDate = new Date(data.startDate);
            const endDate = new Date(data.endDate);

            if (endDate < startDate) {
                Swal.fire({ title: 'Invalid Date', text: 'End date must not be before start date', icon: 'warning', confirmButtonText: 'OK' });
                setSaving(false);
                return;
            }
        }

        // Clean up event owner emails - use emailList instead of data.eventOwner
        const cleanEventOwner = emailList.join(';');

        var eventFormData = new FormData();
        eventFormData.append("eventName", data.eventName);
        eventFormData.append("description", data.description);
        eventFormData.append("startDate", data.startDate);
        eventFormData.append("endDate", data.endDate);
        eventFormData.append("status", data.status);
        eventFormData.append("ConfirmStatus", data.ConfirmStatus);
        eventFormData.append("BehalStatus", data.BehalStatus);
        eventFormData.append("eventOwner", cleanEventOwner);
        // On edit, send the image only when a new one was picked; backend keeps the existing image otherwise
        if (data.file && data.file.length > 0) {
            eventFormData.append("file", data.file[0]);
        }
        if (eventId != null) {
            eventFormData.append("id", data.id);
            eventFormData.append("eventNumber", data.eventNumber);
            axios.put(process.env.REACT_APP_API_END_POINT + '/v1/Events/update', eventFormData,authPut).then(function (response) {
                reset(getValues())
                setSuccessModalShow(true)
                setCreateEvId(response.data.eventNumber);
                setCreateStatus("1")
                setSaving(false)
            }).catch(function (error) {
                setSaving(false)
                if (showSaveError(error)) return;
                setSuccessModalShow(true)
                setCreateEvId("");
                setCreateStatus("0")
            });
        } else {
            //console.log('data=',data);
            axios.post(process.env.REACT_APP_API_END_POINT + '/v1/Events/create', eventFormData, authPut).then(function (response) {
                setSaving(false)
                setSuccessModalShow(true)
                setCreateEvId(response.data.eventNumber);
                setCreateStatus("1")

            })
                .catch(function (error) {
                    setSaving(false)
                    if (showSaveError(error)) return;
                    setSuccessModalShow(true)
                    setCreateEvId("");
                    setCreateStatus("0")
                });
        }


    }
    const onSendEmail = async () => {
        if (!eventId || id === "00") return;
        if (isDirty) {
            Swal.fire({ icon: 'warning', title: t('modal.unsaved_title', 'Unsaved changes'), text: t('modal.unsaved_body', 'Please save the event before sending an email notification.'), confirmButtonColor: '#c5281f' });
            return;
        }
        setSendingEmail(true);
        try {
            await axios.post(
                `${process.env.REACT_APP_API_END_POINT}/v1/Events/${id}/notify`,
                {},
                { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('accessToken') } }
            );
            Swal.fire({ icon: 'success', title: t('modal.email_sent_success', 'Email sent successfully'), confirmButtonColor: '#c5281f' });
        } catch (err: any) {
            const status = err.response?.status;
            const msg = err.response?.data?.message || t('modal.send_failed_body', 'Failed to send email notification.');
            if (status === 429) {
                const retryAfterSeconds: number = err.response?.data?.retryAfterSeconds ?? 300;
                setNotifyModal({ show: true, retryAfterSeconds });
            } else {
                Swal.fire({ icon: 'error', title: t('modal.send_failed', 'Send failed'), text: msg, confirmButtonColor: '#c5281f' });
            }
        } finally {
            setSendingEmail(false);
        }
    };

    const onForceSend = async () => {
        setNotifyModal(prev => ({ ...prev, show: false }));
        setSendingEmail(true);
        try {
            await axios.post(
                `${process.env.REACT_APP_API_END_POINT}/v1/Events/${id}/notify?force=true`,
                {},
                { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('accessToken') } }
            );
            Swal.fire({ icon: 'success', title: t('modal.email_sent_success', 'Email sent successfully'), confirmButtonColor: '#c5281f' });
        } catch (forceErr: any) {
            const forceMsg = (forceErr as any).response?.data?.message || t('modal.send_failed_body', 'Failed to send email notification.');
            Swal.fire({ icon: 'error', title: t('modal.send_failed', 'Send failed'), text: forceMsg, confirmButtonColor: '#c5281f' });
        } finally {
            setSendingEmail(false);
        }
    };

    const onSubmitReward: SubmitHandler<IFormRewardInput> = (data) => {
        if (data.file && data.file.length > 0 && data.file[0].size > MAX_IMAGE_SIZE) {
            Swal.fire({ title: 'Image too large', text: 'Reward image must not exceed 10 MB', icon: 'warning', confirmButtonText: 'OK' });
            return;
        }
        setRewardAdding(true)
        var rewardForm = new FormData();
        rewardForm.append("eventId", id.toString());
        rewardForm.append("rewardName", data.rewardName);
        rewardForm.append("qty", data.qty);
        rewardForm.append("file", data.file[0]);
        axios.post(process.env.REACT_APP_API_END_POINT + '/v1/reward/create', rewardForm, authPut).then(function (response) {
            setRewardAdding(false)
            loadReward()
            resetReward()
        }).catch(function (error) {
            setRewardAdding(false)
            showSaveError(error)
        });
    }

    const onSubmitMember: SubmitHandler<IFormMemberInput> = (data) => {
        setMemberUploading(true)
        var selectedRewards = rewardSelected.map((o: any) => o.value).join(',');
        var memberForm = new FormData();
        memberForm.append("eventId", id.toString());


        if (memberInputType.toString() === "1") {
            memberForm.append("employeeId", data.employeeId);
            memberForm.append("rewardNumber", selectedRewards);
            if (selectedRewards !== "" && data.employeeId !== "") {
                axios.post(process.env.REACT_APP_API_END_POINT + '/v1/member/add', memberForm, authPut).then(function (response) {
                    setMemberUploading(false)
                    loadMember()
                    resetMember()
                    setRewardSelected([])
                    setMemberSuccessStatus(true)
                    setMemberErrorStatus(false);
                }).catch(function (error) {
                    setMemberUploading(false)
                    setMemberErrorStatus(true);
                    setMemberSuccessStatus(false)
                    //setMemberErrorMessage(error.response.data.detailTh);
                });
            } else {
                setMemberUploading(false)
                setMemberErrorStatus(true)
            }
        } else if (memberInputType.toString() === "2") {
            memberForm.append("Limit", "12");
            memberForm.append("Offset", "0");
            memberForm.append("BatchNo", "1");
            memberForm.append("file", data.file[0]);
            axios.post(process.env.REACT_APP_API_END_POINT + '/v1/Upload/ImportExcel', memberForm, authPut).then(function (response) {
                setMemberUploading(false)
                loadMember()
                loadTotalMembers()
                resetMember()
                setRewardSelected([])
                setMemberSuccessStatus(true)
                setMemberErrorStatus(false);
            }).catch(function (error) {
                setMemberUploading(false)
                setMemberErrorStatus(true);
                setMemberSuccessStatus(false)
                console.error('Upload error:', error.response?.status, error.response?.data);
                const d = error.response?.data;
                if (d?.Error) {
                    setMemberErrorMessage(d.Error);
                } else if (d?.detailTh) {
                    setMemberErrorMessage(d.detailTh);
                } else if (d?.detail) {
                    setMemberErrorMessage(d.detail);
                } else if (d?.message) {
                    setMemberErrorMessage(d.message);
                } else if (d?.title) {
                    setMemberErrorMessage(d.title);
                } else {
                    setMemberErrorMessage('Failed to upload file. Please check the file format and data.');
                }
            });
        } else {

            axios.post(process.env.REACT_APP_API_END_POINT + '/v1/member/allEmployee', memberForm, authPut).then(function (response) {
                setMemberUploading(false)
                loadMember()
                resetMember()
                setRewardSelected([])
                setMemberSuccessStatus(true)
                setMemberErrorStatus(false);
            }).catch(function (error) {
                setMemberUploading(false)
                setMemberErrorStatus(true);
                setMemberSuccessStatus(false)
                //setMemberErrorMessage(error.response.data.detailTh);
            });
        }


    }


    // load reward
    const loadReward = () => {
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/reward/reward?eventId=' + id, auth)
            .then(function (response) {
                setRewardLists(response.data);
                loadMemberReward()
                //console.log(response);
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }
    const clearAlert = () => {
        setMemberErrorStatus(false)
        setMemberSuccessStatus(false)
    }
    const loadMemberReward = () => {
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/reward/memberreward?eventId=' + id,auth)
            .then(function (response) {
                setRewardOptions(response.data);
               // console.log(response);
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }
    // load Member
    const loadMember = () => {
        let url = process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + "&offset=" + filter.offset + "&limit=" + filter.limit;
        
        // Add status filter if selected
        if (statusFilter.trim() !== "") {
            url += "&status=" + statusFilter;
        }
        
        // Add search keyword
        if (searchKeyword.trim() !== "") {
            url += "&keyword=" + encodeURIComponent(searchKeyword.trim());
        }
        
        axios.get(url, auth)
            .then(function (response) {
                setMemberLists(response.data);
                //console.log(response);
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    // Load total members count without filter
    const loadTotalMembers = () => {
        if (id === "00") return;
        
        // Get all members count
        const urlAll = process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + "&offset=0&limit=999999";
        
        // Get received members count
        const urlReceived = process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + "&offset=0&limit=999999&status=1";
        
        // Fetch both counts
        Promise.all([
            axios.get(urlAll, auth),
            axios.get(urlReceived, auth)
        ])
        .then(([responseAll, responseReceived]) => {
            setTotalMembersInEvent(responseAll.data.total || 0);
            setTotalReceivedInEvent(responseReceived.data.total || 0);
        })
        .catch(function (error) {
            console.error('Error loading total members:', error);
        });
    }


    //Delete
    const hendleRewardConfirmModal = (rwId: number) => {
        setRewardId(rwId);
        setRewardModalShow(true);
    }
    const hendleMemberConfirmModal = (mbId: number) => {
        setMemberId(mbId);
        setMemberModalShow(true);
    }
    const hendleRewardDelete = () => {
        setRewardModalShow(false)
        axios.delete(process.env.REACT_APP_API_END_POINT + '/v1/Reward/delete?id=' + rewardId,auth)
            .then(function (response) {
                loadReward();
                loadMemberReward();
            })
            .catch(function (error) {
                // handle error
               // console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }
    const hendleMemberDelete = () => {
        setMemberModalShow(false);
        setMemberErrorStatus(false);
        setMemberSuccessStatus(false);
        setLoading(true);

        axios.delete(
            `${process.env.REACT_APP_API_END_POINT}/v1/Member/delete?id=${memberId}`,
            auth
        )
        .then(function (response) {
            if (response.status === 200) {
                setMemberSuccessStatus(true);
                setMemberSuccessMessage('Deleted successfully');
                loadMember();
                loadTotalMembers();
            }
        })
        .catch(function (error) {
            console.error('Error deleting member:', error);
            setMemberErrorStatus(true);
            setMemberErrorMessage('Failed to delete. Please try again.');
        })
        .finally(function () {
            setLoading(false);
        });
    }

    // Checkbox handlers
    const handleSelectMember = (memberId: number) => {
        setSelectedMembers(prev => {
            if (prev.includes(memberId)) {
                return prev.filter(id => id !== memberId);
            } else {
                return [...prev, memberId];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedMembers([]);
            setSelectAll(false);
        } else {
            const allIds = memberLists.memberLists.map((item: any) => item.id);
            setSelectedMembers(allIds);
            setSelectAll(true);
        }
    };

    // Bulk delete selected members
    const handleBulkDelete = () => {
        setBulkDeleteModalShow(false);
        setMemberErrorStatus(false);
        setMemberSuccessStatus(false);
        setLoading(true);

        const deletePromises = selectedMembers.map(id =>
            axios.delete(
                `${process.env.REACT_APP_API_END_POINT}/v1/Member/delete?id=${id}`,
                auth
            )
        );

        Promise.all(deletePromises)
            .then(() => {
                setMemberSuccessStatus(true);
                setMemberSuccessMessage(`Deleted ${selectedMembers.length} item(s) successfully`);
                setSelectedMembers([]);
                setSelectAll(false);
                loadMember();
                loadTotalMembers();
            })
            .catch((error) => {
                console.error('Error bulk deleting members:', error);
                setMemberErrorStatus(true);
                setMemberErrorMessage('Some items could not be deleted. Please try again.');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Delete all filtered members
    const handleDeleteAll = () => {
        setDeleteAllModalShow(false);
        setMemberErrorStatus(false);
        setMemberSuccessStatus(false);
        setIsDeleting(true);

        const deleteUrl = `${process.env.REACT_APP_API_END_POINT}/v1/Member/deleteAll?eventId=${id}`;
        console.log('[DeleteAll] id=', id, 'url=', deleteUrl);

        axios.delete(deleteUrl, auth)
        .then((response) => {
            setMemberSuccessStatus(true);
            setMemberSuccessMessage('All data deleted successfully');
            setSelectedMembers([]);
            setSelectAll(false);
            // If event was in "All Employees" mode, backend resets MemberGroup to 1
            if (memberInputType.toString() === '3') setMemberInputType(1);
            loadMember();
            loadTotalMembers();
        })
        .catch((error) => {
            console.error('Error deleting all members:', error);
            setMemberErrorStatus(true);
            setMemberErrorMessage('Failed to delete. Please try again.');
        })
        .finally(() => {
            setIsDeleting(false);
        });
    };

    const onExportMembers = async () => {
        setIsExporting(true);
        
        // Generate filename with current date and time
        const now = new Date();
        const dateStr = now.getFullYear() + 
            String(now.getMonth() + 1).padStart(2, '0') + 
            String(now.getDate()).padStart(2, '0') + '_' +
            String(now.getHours()).padStart(2, '0') + 
            String(now.getMinutes()).padStart(2, '0') + 
            String(now.getSeconds()).padStart(2, '0');
        const fileName: string = `eventmember_${dateStr}`;
        
        try {
            // Fetch all data for export with current filters
            let exportUrl = `${process.env.REACT_APP_API_END_POINT}/v1/member/Members?eventId=${id}&offset=0&limit=999999`;
            
            if (statusFilter.trim() !== "") {
                exportUrl += `&status=${statusFilter}`;
            }
            
            if (searchKeyword.trim() !== "") {
                exportUrl += `&keyword=${encodeURIComponent(searchKeyword.trim())}`;
            }

            const response = await axios.get(exportUrl, auth);
            
            const exportData = response.data.memberLists.map((item: any) => ({
                'EmployeeId': item.employeeId,
                'EmployeeName': item.displayName || '',
                'Email': item.mail || '',
                'ItemNumber': item.rewardNumber || '',
                'Department': item.department || '',
                'Recieved': (item.recieved === 1 || item.recieved === '1') ? '1' : '0',
            }));

            // Create workbook and worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            
            // Add worksheet to workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, "Members");
            
            // Generate buffer and save file
            XLSX.writeFile(workbook, fileName + '.xlsx');
            
            setMemberSuccessStatus(true);
            setMemberSuccessMessage('Data exported successfully');
            
        } catch (error) {
            console.error('Error exporting members:', error);
            setMemberErrorStatus(true);
            setMemberErrorMessage('Export failed. Please try again.');
        } finally {
            setIsExporting(false);
        }
    };

    const hendleMemberInputType = (e: any) => {
        const { value, name } = e.target
        setMemberInputType(value);
    }
    const handlePageClick = (event: any) => {
        const newOffset = (event.selected * filter.limit) % memberLists.total;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setFilter(oldValues => ({ ...oldValues, ['offset']: newOffset }));
    }

    const handleSearchChange = (e: any) => {
        setSearchKeyword(e.target.value);
    }

    const handleKeyPress = (e: any) => {
        if (e.key === 'Enter') {
            handleSearchSubmit();
        }
    }

    const handleStatusFilterChange = (e: any) => {
        setStatusFilter(e.target.value);
    }

    const handleSearchSubmit = () => {
        setFilter(oldValues => ({ ...oldValues, ['offset']: 0 })); // Reset to first page
        loadMember();
        // Keep focus on search input
        setTimeout(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }, 100);
    }

    const clearAllFilters = () => {
        setSearchKeyword("");
        setStatusFilter("");
        setFilter(oldValues => ({ ...oldValues, ['offset']: 0 })); // Reset to first page
        setTimeout(() => {
            loadMember();
        }, 100);
    }

    // Date validation function
    const validateDates = (startDate: string, endDate: string) => {
        if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            return end >= start;
        }
        return true;
    }

    const handleDateChange = (field: 'startDate' | 'endDate', value: string) => {
        setValue(field, value);
        
        // Get the other date value
        const startDateElement = document.getElementById('startDate') as HTMLInputElement;
        const endDateElement = document.getElementById('endDate') as HTMLInputElement;
        
        if (startDateElement && endDateElement) {
            const startValue = field === 'startDate' ? value : startDateElement.value;
            const endValue = field === 'endDate' ? value : endDateElement.value;
            
            if (startValue && endValue && !validateDates(startValue, endValue)) {
                if (field === 'endDate') {
                    endDateElement.setCustomValidity('End Date cannot be earlier than Start Date');
                } else {
                    endDateElement.setCustomValidity('End Date cannot be earlier than Start Date');
                }
            } else {
                endDateElement.setCustomValidity('');
            }
        }
    }

    // Email management functions
    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const addEmail = (email: string) => {
        const trimmedEmail = email.trim().toLowerCase();
        if (trimmedEmail && validateEmail(trimmedEmail) && !emailList.includes(trimmedEmail)) {
            const newEmailList = [...emailList, trimmedEmail];
            setEmailList(newEmailList);
            setValue("eventOwner", newEmailList.join(';'));
            setCurrentEmail("");
        }
    }

    const removeEmail = (emailToRemove: string) => {
        const newEmailList = emailList.filter(email => email !== emailToRemove);
        setEmailList(newEmailList);
        setValue("eventOwner", newEmailList.join(';'));
    }

    const handleEmailInputKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addEmail(currentEmail);
        }
    }

    const searchOrgUsers = async (query: string) => {
        if (query.length < 2) {
            setOwnerSuggestions([]);
            return;
        }
        setOwnerSearchLoading(true);
        try {
            const response = await axios.get(
                `https://graph.microsoft.com/v1.0/users?$filter=startswith(mail,'${encodeURIComponent(query)}')&$select=displayName,mail&$top=10`,
                { headers: { Authorization: `Bearer ${tokenProfile}` } }
            );
            setOwnerSuggestions((response.data.value || []).filter((u: any) => u.mail));
        } catch {
            setOwnerSuggestions([]);
        } finally {
            setOwnerSearchLoading(false);
        }
    };

    const handleEmailInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setCurrentEmail(value);
        if (ownerSearchTimeout.current) clearTimeout(ownerSearchTimeout.current);
        ownerSearchTimeout.current = setTimeout(() => searchOrgUsers(value), 300);
    };

    // Image preview function
    const MAX_FILE_MB = 5;
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setImageWarning(null);

        // Size check — hard limit 5 MB
        if (file.size > MAX_FILE_MB * 1024 * 1024) {
            setImageWarning(`File too large (${(file.size / 1024 / 1024).toFixed(1)} MB). Maximum is ${MAX_FILE_MB} MB.`);
            e.target.value = '';
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            const dataUrl = event.target?.result as string;
            setPreviewImage(dataUrl);

            // Ratio check — warn if not 16:9 (±10% tolerance)
            const img = new Image();
            img.onload = () => {
                const ratio = img.width / img.height;
                const target = 16 / 9;
                if (Math.abs(ratio - target) / target > 0.1) {
                    setImageWarning(
                        `Image ratio is ${img.width}×${img.height} (${(ratio).toFixed(2)}:1). Recommended 16:9 (e.g. 1280×720 or 1920×1080) for best display.`
                    );
                }
            };
            img.src = dataUrl;
        };
        reader.readAsDataURL(file);
    }

    // ...existing code...
    useEffect(() => {
        if (eventId != null) {
           setLoading(true)
            axios.get(process.env.REACT_APP_API_END_POINT + '/v1/Events/event?eventNumber=' + eventId,auth)
                .then(function (response) {
                    setValue("id", response.data.id);
                    setValue("eventNumber", response.data.eventNumber);
                    setValue("eventName", response.data.eventName);
                    setValue("eventOwner", response.data.owner);
                    // Initialize email list from owner data
                    if (response.data.owner) {
                        const emails = response.data.owner
                            .replace(/[,;]/g, ';')
                            .split(';')
                            .map((email: string) => email.trim().toLowerCase())
                            .filter((email: string) => email.length > 0);
                        setEmailList(emails);
                    }
                    setValue("description", response.data.description);
                    setValue("startDate", response.data.startDate);
                    setValue("endDate", response.data.endDate);
                    setValue("status", response.data.status);
                    setValue("ConfirmStatus", response.data.confirmStatus);
                    setValue("BehalStatus", response.data.behalStatus);
                    // Set preview image if exists
                    if (response.data.image) {
                        setPreviewImage(getImageSrc(response.data.image));
                    }
                    setImageWarning(null);
                    //console.log(response.data.owner);
                    setId(response.data.id);
                    setEventdata(response.data);
                    // Convert memberGroup to number and set default to 1 if invalid
                    const memberGroupValue = response.data.memberGroup;
                    const parsedMemberGroup = memberGroupValue ? parseInt(memberGroupValue.toString()) : 1;
                    setMemberInputType(parsedMemberGroup);
                    setLoading(false)
                })
                .catch(function (error) {
                    // handle error
                    setLoading(false)
                   // console.log(error);
                })
                .finally(function () {
                   setLoading(false)
                    // always executed
                });

        }

    }, [token,eventId])


    useEffect( () => {
        if (!token && inProgress === InteractionStatus.None) {
         acquireGetAccessToken(instance, accounts).then(async (res: any) => {
                if (!res) return;
                setToken(res.accessToken)
                setTokenProfile(res.accessTokenProfile)
                // Users without a profile photo get 404 here — must not block loading the profile below
                try {
                    const response1 = await axios("https://graph.microsoft.com/v1.0/me/photo/$value", {
                        headers: { Authorization: `Bearer ${res.accessTokenProfile}` },
                        responseType: "arraybuffer"
                    });
                    const avatar = Buffer.from(response1.data, "binary").toString("base64");
                    setPhotoData("data:image/jpeg;base64, " + avatar);
                    sessionStorage.setItem("PhotoData", "data:image/jpeg;base64, " + avatar);
                } catch { /* no photo */ }


                const response2 = await axios("https://graph.microsoft.com/v1.0/me", {
                    headers: { Authorization: `Bearer ${res.accessTokenProfile}` }
                });
                setProfile(response2.data);
              //  sessionStorage.setItem("Profile", response2.data);
            }) 
        }
      }, [inProgress]);



      useEffect ( () => {
        const CheckRole = async () => {
            if (!tokenProfile) return;
            if (eventdata.owner && (profile.mail || profile.userPrincipalName)) {
                try {
                    const ownerExists = isOwnerOf(eventdata.owner, getUserEmails(profile, accounts[0]));
                    const groupExists = await checkIsAdmin(tokenProfile);
                    setIsAdmin(groupExists)
                    if (groupExists || ownerExists) {
                        setStateLoad(true)
                    } else {
                        // Redirect to access denied page
                        window.location.href = `${window.location.origin}/accessdenied`;
                    }
                } catch(error) {
                    console.error('error=',error);
                    setLoading(false)
                }
           } else if (!eventId) {
                // Create mode — admin/superadmin only
                try {
                    const groupExists = await checkIsAdmin(tokenProfile);
                    setIsAdmin(groupExists)
                    if (groupExists) {
                        setStateLoad(true)
                    } else {
                        window.location.href = `${window.location.origin}/accessdenied`;
                    }
                } catch(error) {
                    console.error('error=',error);
                }
           }
        }

    CheckRole();

    }, [profile.mail, profile.userPrincipalName, eventdata.owner, tokenProfile, eventId])

    useEffect(() => {
        if (id !== "00") {
            loadReward()
            loadMember()
            loadMemberReward()
            loadTotalMembers()
        }

    }, [id])

    useEffect(() => {
        const timer = setTimeout(() => {
            setMemberErrorStatus(false)
            setMemberSuccessStatus(false)
        }, 5000);

        // Cleanup the timer when the component is unmounted
        return () => clearTimeout(timer);
    }, [memberErrorStatus, memberSuccessStatus])
    useEffect(() => {
        if (id !== "00") {
            loadMember()
            setSelectedMembers([])
            setSelectAll(false)
        }
    }, [filter.offset])

    useEffect(() => {
        if (id !== "00" && searchKeyword === "") {
            loadMember()
            setSelectedMembers([])
            setSelectAll(false)
        }
    }, [searchKeyword])

    useEffect(() => {
        if (id !== "00") {
            loadMember()
            setSelectedMembers([])
            setSelectAll(false)
        }
    }, [statusFilter])
    // console.log('stateLoad====',stateLoad);
    // console.log('loading====',loading);
    return (
        <>
        {(!loading && stateLoad) ? <div className="admin-layout">
            <Topbar  token={token}  photoData={photoData} isAdmin={isAdmin} />
            <main className="admin-main">
            <div className='container mt-4'>
                <div className='mb-3'>
                    <button
                        className='btn btn-sm'
                        onClick={() => navigate(-1)}
                        style={{
                            display: 'inline-flex', alignItems: 'center', gap: 6,
                            background: 'var(--n-100)', border: 'none',
                            borderRadius: 'var(--r-sm)', padding: '6px 14px',
                            color: 'var(--n-700)', fontWeight: 500, fontSize: '0.875rem',
                        }}
                    >
                        ← {t('btn.back', 'Back')}
                    </button>
                </div>
                <div className='card border-0 event-form-tab'>
                    <Tabs
                        activeKey={activeTab}
                        onSelect={k => navigate(`${location.pathname}${location.search}#${k ?? 'event'}`, { replace: true })}
                        id="fill-tab-example"
                        className="mb-3"
                    >
                        <Tab eventKey="event" title={t('tab.event_info', 'Event information')} >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <input type='hidden' {...register("id")} value="" />
                                {/* ── Two-column layout: fields left, image right ── */}
                                <div className='row mx-5 mt-4 g-4 align-items-start'>

                                    {/* Left col — form fields */}
                                    <div className='col-7'>
                                        <div className="mb-3">
                                            <label className="form-label">{t('form.event_name', 'Event Name')} <span className="text-danger">*</span></label>
                                            <input type="text" id="eventName" className="form-control" placeholder="" {...register("eventName", { required: true })} required />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{t('form.description', 'Description')}</label>
                                            <textarea className='form-control' rows={6} {...register("description")}></textarea>
                                        </div>
                                        <div className="row g-3">
                                            <div className='col-6'>
                                                <label className="form-label">{t('form.confirm_receive', 'Users Confirm Receive')}</label>
                                                <select className="form-select" {...register("ConfirmStatus")}>
                                                    <option value="0">{t('option.no', 'No')}</option>
                                                    <option value="1">{t('option.yes', 'Yes')}</option>
                                                </select>
                                            </div>
                                            <div className='col-6'>
                                                <label className="form-label">{t('form.substitute', 'Substitute')}</label>
                                                <select className="form-select" {...register("BehalStatus")}>
                                                    <option value="0">{t('option.no', 'No')}</option>
                                                    <option value="1">{t('option.yes', 'Yes')}</option>
                                                </select>
                                            </div>
                                            <div className='col-6'>
                                                <label className="form-label">{t('form.start_date', 'Start Date')} <span className="text-danger">*</span></label>
                                                <input type="date" {...register("startDate", { required: true })} className="form-control" id="startDate" required onChange={(e) => handleDateChange('startDate', e.target.value)} />
                                            </div>
                                            <div className='col-6'>
                                                <label className="form-label">{t('form.end_date', 'End Date')} <span className="text-danger">*</span></label>
                                                <input type="date" {...register("endDate", { required: true })} className="form-control" id="endDate" required onChange={(e) => handleDateChange('endDate', e.target.value)} />
                                            </div>
                                            <div className='col-6'>
                                                <label className="form-label">{t('form.status', 'Status')}</label>
                                                <select className="form-select" {...register("status")}>
                                                    <option value="1">{t('status.inactive', 'Inactive')}</option>
                                                    <option value="2">{t('status.active', 'Active')}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right col — image zone */}
                                    <div className='col-5'>
                                        <label className="form-label">
                                            {t('form.event_image', 'Event Image')}
                                            {eventId === null && <span className="text-danger"> *</span>}
                                        </label>

                                        <input
                                            type="file"
                                            id="eventFile"
                                            style={{ display: 'none' }}
                                            {...register("file", { required: eventId === null })}
                                            accept=".jpg,.jpeg,.png"
                                            onChange={(e) => {
                                                handleImageChange(e);
                                                register("file").onChange(e);
                                            }}
                                        />

                                        {/* Upload zone — 16:9 aspect ratio */}
                                        <div
                                            onClick={() => document.getElementById('eventFile')?.click()}
                                            style={{
                                                position: 'relative',
                                                width: '100%',
                                                aspectRatio: '16/9',
                                                borderRadius: 'var(--r-md)',
                                                border: imageWarning
                                                    ? '2px dashed #f59e0b'
                                                    : previewImage ? '2px solid var(--n-200)' : '2px dashed var(--n-300)',
                                                background: previewImage ? 'transparent' : 'var(--n-50)',
                                                cursor: 'pointer',
                                                overflow: 'hidden',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                            onMouseEnter={e => {
                                                const ov = e.currentTarget.querySelector('.img-overlay') as HTMLElement | null;
                                                if (ov) ov.style.opacity = '1';
                                            }}
                                            onMouseLeave={e => {
                                                const ov = e.currentTarget.querySelector('.img-overlay') as HTMLElement | null;
                                                if (ov) ov.style.opacity = '0';
                                            }}
                                        >
                                            {previewImage ? (
                                                <>
                                                    <img
                                                        src={previewImage}
                                                        alt="Event Preview"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', position: 'absolute', inset: 0 }}
                                                    />
                                                    <div className="img-overlay" style={{
                                                        position: 'absolute', inset: 0,
                                                        background: 'rgba(0,0,0,0.45)',
                                                        display: 'flex', flexDirection: 'column',
                                                        alignItems: 'center', justifyContent: 'center',
                                                        gap: 8, opacity: 0, transition: 'opacity 0.2s',
                                                        color: '#fff', fontSize: '0.9rem', fontWeight: 600,
                                                    }}>
                                                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                                                        Change Image
                                                    </div>
                                                </>
                                            ) : (
                                                <div style={{ textAlign: 'center', color: 'var(--n-400)', padding: 24 }}>
                                                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ display: 'block', margin: '0 auto 12px' }}><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                                                    <div style={{ fontSize: '0.88rem', fontWeight: 600, marginBottom: 6 }}>Click to upload image</div>
                                                    <div style={{ fontSize: '0.75rem', lineHeight: 1.6 }}>
                                                        <span style={{ color: 'var(--n-500)', fontWeight: 600 }}>JPG · JPEG · PNG</span>
                                                        <span style={{ color: 'var(--n-300)' }}> · Max {MAX_FILE_MB} MB</span><br />
                                                        <span style={{ color: 'var(--n-500)', fontWeight: 600 }}>Recommended: 16:9</span><br />
                                                        <span style={{ color: 'var(--n-300)' }}>e.g. 1280×720 or 1920×1080</span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Required image warning — new event only */}
                                        {eventId === null && !previewImage && (
                                            <div style={{
                                                marginTop: 8, padding: '7px 12px',
                                                background: '#fef2f2', border: '1px solid #fecaca',
                                                borderRadius: 'var(--r-sm)',
                                                fontSize: '0.78rem', color: '#991b1b',
                                                display: 'flex', gap: 6, alignItems: 'flex-start',
                                            }}>
                                                <span style={{ flexShrink: 0, marginTop: 1 }}>📷</span>
                                                <span>{t('validation.image_required', 'Please upload an event image. Image is required to create a new event.')}</span>
                                            </div>
                                        )}

                                        {/* Ratio / size warning */}
                                        {imageWarning && (
                                            <div style={{
                                                marginTop: 8, padding: '7px 12px',
                                                background: '#fffbeb', border: '1px solid #fcd34d',
                                                borderRadius: 'var(--r-sm)',
                                                fontSize: '0.78rem', color: '#92400e',
                                                display: 'flex', gap: 6, alignItems: 'flex-start',
                                            }}>
                                                <span style={{ flexShrink: 0, marginTop: 1 }}>⚠️</span>
                                                <span>{imageWarning}</span>
                                            </div>
                                        )}
                                    </div>

                                    {/* Event Owner — full width below */}
                                    <div className='col-12'>
                                        <div className="mb-3">
                                            <label className="form-label">{t('form.event_owner', 'Event Owner(s)')} <span className="text-danger">*</span></label>
                                            <input type="hidden" {...register("eventOwner")} />
                                                    
                                                    {/* Email Tags Display */}
                                                    {emailList.length > 0 && (
                                                        <div className="mb-2">
                                                            {emailList.map((email, index) => (
                                                                <span key={index} className="badge bg-primary me-2 mb-1 d-inline-flex align-items-center">
                                                                    {email}
                                                                    <button 
                                                                        type="button"
                                                                        className="btn-close btn-close-white ms-2"
                                                                        style={{ fontSize: '0.6em' }}
                                                                        onClick={() => removeEmail(email)}
                                                                        aria-label="Remove email"
                                                                    ></button>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                    
                                                    {/* Email Search Input */}
                                                    <div className="position-relative">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder={t('placeholder.search_email', 'Search by email address...')}
                                                            value={currentEmail}
                                                            onChange={handleEmailInputChange}
                                                            onKeyPress={handleEmailInputKeyPress}
                                                            onBlur={() => setTimeout(() => setOwnerSuggestions([]), 200)}
                                                            autoComplete="off"
                                                        />
                                                        {ownerSearchLoading && (
                                                            <div className="position-absolute end-0 top-50 translate-middle-y pe-3">
                                                                <span className="spinner-border spinner-border-sm text-secondary" role="status" />
                                                            </div>
                                                        )}
                                                        {ownerSuggestions.length > 0 && (
                                                            <ul className="list-group position-absolute w-100 shadow" style={{ zIndex: 1000, top: '100%' }}>
                                                                {ownerSuggestions.map((user, i) => (
                                                                    <li
                                                                        key={i}
                                                                        className="list-group-item list-group-item-action py-2"
                                                                        style={{ cursor: 'pointer' }}
                                                                        onMouseDown={() => {
                                                                            addEmail(user.mail);
                                                                            setOwnerSuggestions([]);
                                                                        }}
                                                                    >
                                                                        <span className="fw-semibold">{user.displayName}</span>
                                                                        <small className="text-muted ms-2">{user.mail}</small>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        )}
                                                    </div>

                                                    {/* Required field indicator */}
                                                    {emailList.length === 0 && (
                                                        <div className="text-danger small mt-1">
                                                            {t('validation.owner_required', 'At least one event owner email is required')}
                                                        </div>
                                                    )}

                                                    <small className="form-text text-muted">
                                                        {t('hint.owner_search', 'Type to search org email • Select from dropdown or press Enter to add manually')}
                                                    </small>
                                        </div>
                                    </div>
                                    <div className='col-12 text-end py-3 d-flex justify-content-end align-items-center gap-2'>
                                        <Button type='reset' className='btn-width btn-cancel'>{t('btn.reset', 'Reset')}</Button>
                                        <Button type='submit' variant="success" className='btn-width btn-save' disabled={saving}>
                                            {saving
                                                ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />{t('btn.saving', 'Saving...')}</>
                                                : t('btn.save', 'Save')
                                            }
                                        </Button>
                                        <Button
                                            type='button'
                                            variant='outline-primary'
                                            className='btn-width'
                                            disabled={!eventId || id === "00" || sendingEmail}
                                            onClick={onSendEmail}
                                            title={!eventId ? 'Save the event first' : isDirty ? 'Save changes before sending' : 'Send email to all members'}
                                        >
                                            {sendingEmail
                                                ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />Sending...</>
                                                : <><BiMailSend size={16} className='me-1' />{t('btn.send_email', 'Send Email')}</>
                                            }
                                        </Button>
                                    </div>
                                </div>

                            </form>
                        </Tab>
                        <Tab eventKey="items" title={eventId === null ? t('tab.reward_items_disabled', 'Reward Items (Save Event first)') : t('tab.reward_items', 'Reward Items')} disabled={(eventId != null) ? false : true}>
                            <form onSubmit={submitReward(onSubmitReward)}>
                                <div className='row mx-3 align-items-end mt-4'>

                                    <div className='col-4'>
                                        <div className="mb-0">
                                            <label className="form-label">{t('form.item_name', 'Item Name')}</label>
                                            <input type="text" className="form-control" placeholder="" {...registerReward("rewardName", { required: true })} />
                                        </div>
                                    </div>
                                    <div className='col-4'>
                                        <div className="mb-0">
                                            <label className="form-label">{t('form.item_image', 'Item Image')}</label>
                                            <input type="file" className="form-control"  {...registerReward("file", { required: true })} />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="mb-0">
                                            <label className="form-label">{t('form.qty_per_user', 'Qty. per user')}</label>
                                            <input type="number" className="form-control" {...registerReward("qty", { required: true })} />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <button className="btn btn-add w-100" type="submit" disabled={rewardAdding}>
                                            {rewardAdding
                                                ? <><span className="spinner-border spinner-border-sm me-1" /> Adding…</>
                                                : <><BiGift size={22} /> <span>{t('btn.add_item', 'Add Item')}</span></>}
                                        </button>
                                    </div>

                                    <div className='col-12'>
                                        <table className="table items-table mt-4"  >
                                            <thead className='tbl-header'>
                                                <tr>
                                                    <th scope="col">{t('table.col.item_number', 'Item Number')}</th>
                                                    <th scope="col">{t('table.col.image', 'Image')}</th>
                                                    <th scope="col">{t('table.col.item_name', 'Item Name')}</th>
                                                    <th scope="col" className='text-center px-4'>{t('table.col.qty_per_user', 'Qty per user')}</th>
                                                    <th scope="col">{t('table.col.action', 'Action')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    (rewardLists.length > 0) ?
                                                        rewardLists.map(
                                                            (item: any,
                                                                index: number) => (
                                                                <tr key={index}>
                                                                    <td className='fw-bold'> {item.rewardNumber}</td>
                                                                    <td>
                                                                        <img src={getImageSrc(item.image)} />
                                                                    </td>
                                                                    <td>{item.rewardName}</td>
                                                                    <td className='text-center'>{item.qty}</td>
                                                                    <td>
                                                                        <button type="button" className='btn btn-link text-danger p-0' onClick={() => hendleRewardConfirmModal(item.id)}>
                                                                            <BiSolidTrash />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )
                                                        :
                                                        <tr>
                                                            <td colSpan={5} className='text-center py-4 text-secondary'>
                                                                <BiGift size={32} className='mb-2 d-block mx-auto' />
                                                                <div>{t('empty.reward_items', 'No reward items yet')}</div>
                                                                <small>{t('empty.reward_items_hint', 'Fill in the form above and click "Add Item" to add')}</small>
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </form>
                        </Tab>
                        <Tab eventKey="employee" title={eventId === null ? t('tab.receive_users_disabled', 'Receive Users (Save Event first)') : t('tab.receive_users', 'Receive Users')} disabled={(eventId != null) ? false : true}>
                            <form onSubmit={submitMember(onSubmitMember)}>
                                <div className='row mx-3 align-items-end mt-4'>
                                    <div className={`${(memberInputType.toString() === "3") ? "col-10" : "col-3"}`}>
                                        <div className="mb-0">
                                            <label className="form-label">{t('form.type', 'Type')}</label>
                                            <select className="form-select" {...registerMember("inputtype")} onChange={(e: any) => hendleMemberInputType(e)} value={memberInputType}>
                                                <option value="1">{t('option.employee_id', 'Employee ID')}</option>
                                                <option value="2">{t('option.excel_file', 'Excel file')}</option>
                                                <option value="3">{t('option.all_employees', 'All employees')}</option>
                                            </select>
                                        </div>
                                    </div>
                                    {
                                        (memberInputType.toString() !== "3") ?
                                            (memberInputType.toString() === "2") ?
                                            <>
                                                <div className='col-7'>
                                                    <div className="mb-0">
                                                        <label className="form-label">{t('form.upload_file_label', 'List of users file')} (<strong>{t('note.label', 'Note')}:</strong> {t('note.upload_filename', 'uploaded file must be named')} <strong className="text-danger">eventmember.xlsx</strong>)</label>
                                                        <input type="file" className="form-control" placeholder="" {...registerMember("file", { required: true })} accept=".xlsx,.xls" />
                                                    </div>
                                                </div>
                                            </>
                                                :
                                                <>
                                                    <div className='col-4'>
                                                        <div className="mb-0">
                                                            <label className="form-label">{t('form.employee_id_7digits', 'Employee Id 7 Digits')}</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="xxxxxxx"
                                                                {...registerMember("employeeId", { 
                                                                    required: true,
                                                                    pattern: {
                                                                        value: /^\d{7}$/,
                                                                        message: "Employee ID must be exactly 7 digits"
                                                                    }
                                                                })}
                                                                maxLength={7}
                                                                onKeyPress={(e) => {
                                                                    // Allow only numbers
                                                                    if (!/[0-9]/.test(e.key)) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className='col-3'>
                                                        <div className="mb-0">
                                                            <MultiSelect
                                                                options={rewardOptions}
                                                                value={rewardSelected}
                                                                onChange={setRewardSelected}
                                                                labelledBy="Select"
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            : <></>
                                    }
                                    <div className='col-2'>
                                        <button className="btn btn-add w-100" type='submit' disabled={memberUploading}>
                                            {memberUploading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    <span style={{ color: 'black' }}>{t('btn.uploading', 'Uploading...')}</span>
                                                </>
                                            ) : (
                                                <>
                                                    <BiUserPlus size={26} /> <span>{t('btn.add_member', 'Add Member')}</span>
                                                </>
                                            )}
                                        </button>
                                    </div>
                                    {/* {(memberInputType.toString() === "2") && (
                                        <div className='col-2'>
                                            <a href='./files/eventmember.xlsx' download={true} aria-label="Download Excel Template">
                                                <button className='btn btn-success w-100' type='button' title="Download Template">
                                                    <PiMicrosoftExcelLogoDuotone size={22} /> Sample file 
                                                </button>
                                            </a>
                                        </div>
                                    )} */}
                                    {
                                        (memberErrorStatus) ?
                                            <div className='col-12'>
                                                <div className='w-100 mt-3 error-dailog'>
                                                    <BiErrorCircle size={22} /> {memberErrorMessage}
                                                </div>
                                            </div>
                                            :
                                            <></>
                                    }
                                    {
                                        (memberSuccessStatus) ?
                                            <div className='col-12'>
                                                <div className='w-100 mt-3 success-dailog'>
                                                    <BiCheckCircle size={22} /> {memberSuccessMessage}
                                                </div>
                                            </div>
                                            :
                                            <></>
                                    }
                                    <div className='col-12 mt-3'>
                                        <div className="row align-items-end">
                                            <div className="col-lg-8 col-md-8 col-sm-12">
                                                <label className="form-label">{t('form.search_by_employee_id', 'Search by Employee ID')}</label>
                                                <input
                                                    ref={searchInputRef}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t('placeholder.employee_id_7digits', 'Enter Employee ID 7 Digits')}
                                                    value={searchKeyword}
                                                    onChange={handleSearchChange}
                                                    onKeyPress={handleKeyPress}
                                                />
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <label className="form-label">{t('form.status', 'Status')}</label>
                                                <select
                                                    className="form-select"
                                                    value={statusFilter}
                                                    onChange={handleStatusFilterChange}
                                                >
                                                    <option value="">{t('option.all', 'All')}</option>
                                                    <option value="1">{t('status.received', 'Received')}</option>
                                                    <option value="0">{t('status.not_received', 'Not Received')}</option>
                                                </select>
                                            </div>
                                            <div className="col-12 mt-3">
                                                <div className="d-flex gap-2 justify-content-between align-items-center flex-wrap">
                                                    <div className="d-flex gap-2">
                                                        <button type="button" className="btn btn-primary" onClick={handleSearchSubmit}>
                                                            <BiSearchAlt size={18} /> {t('btn.search', 'Search')}
                                                        </button>
                                                        {(searchKeyword || statusFilter) && (
                                                            <button type="button" className="btn btn-secondary" onClick={clearAllFilters}>
                                                                {t('btn.clear_filters', 'Clear Filters')}
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                        {memberInputType.toString() === "2" && (
                                                            <a href='./files/eventmember.xlsx' download={true} aria-label="Download Excel Template">
                                                                <button className='btn btn-info' type='button' title={t('btn.download_template', 'Download Template')}>
                                                                    <PiMicrosoftExcelLogoDuotone size={18} /> {t('btn.sample_upload_file', 'Sample Upload file')}
                                                                </button>
                                                            </a>
                                                        )}
                                                        {memberLists.memberLists.length > 0 && (
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-success" 
                                                                onClick={onExportMembers}
                                                                disabled={isExporting}
                                                            >
                                                                {isExporting ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        {t('btn.exporting', 'Exporting...')}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <PiMicrosoftExcelLogoDuotone size={18} /> {t('btn.export', 'Export')}
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}
                                                        {memberLists.memberLists.length > 0 && memberInputType.toString() !== "3" && selectedMembers.length > 0 && (
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-danger" 
                                                                onClick={() => setBulkDeleteModalShow(true)}
                                                            >
                                                                <BiSolidTrash size={18} /> {t('btn.delete_selected', 'Delete Selected')} ({selectedMembers.length})
                                                            </button>
                                                        )}
                                                        {memberLists.memberLists.length > 0 && memberInputType.toString() !== "3" && (
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-outline-danger" 
                                                                onClick={() => setDeleteAllModalShow(true)}
                                                                disabled={isDeleting}
                                                            >
                                                                {isDeleting ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                        {t('btn.deleting', 'Deleting...')}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <BiSolidTrash size={18} /> {t('btn.delete_all', 'Delete All')}
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <table className="table user-table  mt-4">
                                            <thead className='tbl-header'>
                                                <tr>
                                                    {memberInputType.toString() !== "3" && (
                                                        <th scope="col" style={{ width: '50px' }}>
                                                            <input 
                                                                type="checkbox" 
                                                                className="form-check-input" 
                                                                checked={selectAll}
                                                                onChange={handleSelectAll}
                                                                disabled={memberLists.memberLists.length === 0}
                                                            />
                                                        </th>
                                                    )}
                                                    <th scope="col" style={{ whiteSpace: 'nowrap' }}>{t('table.col.employee_id', 'Employee Id')}</th>
                                                    <th scope="col" style={{ whiteSpace: 'nowrap' }}>{t('table.col.employee_name', 'Employee Name')}</th>
                                                    <th scope="col">Email</th>
                                                    <th scope="col" style={{ whiteSpace: 'nowrap', width: '80px' }}>{t('table.col.item', 'Item')}</th>
                                                    <th scope="col">{t('table.col.department', 'Department')}</th>
                                                    <th scope="col">{t('table.col.status', 'Status')}</th>
                                                    {memberInputType.toString() !== "3" && (
                                                        <th scope="col" className='text-center'>{t('table.col.action', 'Action')}</th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    (memberLists.memberLists.length > 0) ?
                                                        memberLists.memberLists.map(
                                                            (item: any,
                                                                index: number) => (
                                                                <tr key={index}>
                                                                    {memberInputType.toString() !== "3" && (
                                                                        <td>
                                                                            <input 
                                                                                type="checkbox" 
                                                                                className="form-check-input"
                                                                                checked={selectedMembers.includes(item.id)}
                                                                                onChange={() => handleSelectMember(item.id)}
                                                                            />
                                                                        </td>
                                                                    )}
                                                                    <td>{item.employeeId}</td>
                                                                    <td>{item.displayName}</td>
                                                                    <td>{item.mail}</td>
                                                                    <td style={{ whiteSpace: 'nowrap' }}>{item.rewardNumber}</td>
                                                                    <td>{item.department}</td>
                                                                    <td>
                                                                        <span className={`badge ${item.recieved === 1 || item.recieved === '1' ? 'bg-success' : 'bg-secondary'}`}>
                                                                            {item.recieved === 1 || item.recieved === '1' ? t('status.received', 'Received') : t('status.not_received', 'Not Received')}
                                                                        </span>
                                                                    </td>
                                                                    {memberInputType.toString() !== "3" && (
                                                                        <td className="text-center">
                                                                            <button type="button" className='btn btn-link text-danger p-0' onClick={() => hendleMemberConfirmModal(item.id)}>
                                                                                <BiSolidTrash />
                                                                            </button>
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            )
                                                        )
                                                        :
                                                        <tr>
                                                            <td colSpan={memberInputType.toString() !== "3" ? 8 : 7} className='text-center p-5 text-secondary'>{t('empty.member_data', 'No member data')}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="text-muted">
                                                <strong>{t('label.total_members', 'Total Members')}:</strong> {totalMembersInEvent}  |
                                                <strong> {t('label.received', 'Received')}:</strong> {totalReceivedInEvent}
                                                {(searchKeyword || statusFilter) && (
                                                    <span className="ms-2">
                                                        ({t('label.search_results', 'Search results')}: {memberLists.total} {t('label.items', 'items')})
                                                    </span>
                                                )}
                                            </div>
                                            <ReactPaginate
                                                className='pagination mb-0'
                                                breakLabel="..."
                                                nextLabel=">"
                                                onPageChange={(e: any) => handlePageClick(e)}
                                                pageRangeDisplayed={5}
                                                pageCount={memberLists.totalPages}
                                                previousLabel="<"
                                                renderOnZeroPageCount={null}
                                                pageClassName='page-item'
                                                pageLinkClassName='page-link'
                                                activeClassName='active'
                                                previousClassName='page-item'
                                                nextClassName='page-item'
                                                previousLinkClassName='page-link'
                                                nextLinkClassName='page-link'
                                            />
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </Tab>
                    </Tabs>

                </div>

            </div>
            </main>
            <RewardConfirmModal
                show={rewardModalShow}
                onHide={() => setRewardModalShow(false)}
                onDelete={() => hendleRewardDelete()}
                titleText={t('modal.confirm_delete', 'Confirm Delete')}
                bodyText={t('modal.delete_reward_body', 'Are you sure you want to delete this reward item?')}
                cancelText={t('btn.cancel', 'Cancel')}
                deleteText={t('btn.delete', 'Delete')}
            />
            <MemberConfirmModal
                show={memberModalShow}
                onHide={() => setMemberModalShow(false)}
                onDelete={() => hendleMemberDelete()}
                titleText={t('modal.confirm_delete', 'Confirm Delete')}
                bodyText={t('modal.delete_member_body', 'Are you sure you want to delete this member?')}
                cancelText={t('btn.cancel', 'Cancel')}
                deleteText={t('btn.delete', 'Delete')}
            />
            <BulkDeleteConfirmModal
                show={bulkDeleteModalShow}
                onHide={() => setBulkDeleteModalShow(false)}
                onDelete={() => handleBulkDelete()}
                count={selectedMembers.length}
                titleText={t('modal.confirm_delete', 'Confirm Delete')}
                bodyText={t('modal.bulk_delete_body', `Are you sure you want to delete ${selectedMembers.length} selected item(s)?`)}
                cancelText={t('btn.cancel', 'Cancel')}
                deleteAllText={t('btn.delete_all', 'Delete All')}
            />
            <DeleteAllConfirmModal
                show={deleteAllModalShow}
                onHide={() => setDeleteAllModalShow(false)}
                onDelete={() => handleDeleteAll()}
                total={memberLists.total}
                filters={{
                    keyword: searchKeyword,
                    status: statusFilter
                }}
                titleText={t('modal.confirm_delete_all', 'Confirm Delete All')}
                warningLabel={t('label.warning', 'Warning')}
                warningBody={t('modal.delete_all_warning_body', 'You are about to delete all members shown in the current list')}
                activeFiltersLabel={t('label.active_filters', 'Active filters')}
                keywordLabel={t('label.keyword', 'Keyword')}
                statusLabel={t('form.status', 'Status')}
                receivedLabel={t('status.received', 'Received')}
                notReceivedLabel={t('status.not_received', 'Not Received')}
                allMembersMsg={t('modal.delete_all_members_msg', `All members (${memberLists.total} items) in this event will be deleted`)}
                cannotUndoMsg={t('modal.cannot_undo', 'This action cannot be undone!')}
                cancelText={t('btn.cancel', 'Cancel')}
                confirmDeleteAllText={t('btn.confirm_delete_all', 'Confirm Delete All')}
            />
            <SuccessModal
                show={successModalShow}
                onHide={() => setSuccessModalShow(false)}
                onOk={() => {
                    setSuccessModalShow(false);
                    if (createStatus === "1" && !eventId) {
                        navigate(`/events?id=${createEvId}`);
                    }
                }}
                result={createStatus}
                eventId={createEvId}
                titleSuccess={t('modal.save_success', 'Save Successful')}
                titleFailed={t('modal.save_failed', 'Save Failed')}
                msgSuccess={t('modal.event_created_success', 'Event created successfully')}
                msgFailed={t('modal.event_created_failed', 'Failed to create event. Please try again.')}
            />
            <NotifyRateLimitModal
                show={notifyModal.show}
                retryAfterSeconds={notifyModal.retryAfterSeconds}
                onHide={() => setNotifyModal(prev => ({ ...prev, show: false }))}
                onForceConfirm={onForceSend}
                t={t}
            />
        </div>:<><LoadingScreen /></>
        }
        </>

    )
}

Events.propTypes = {

}

export default Events
